"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePaginatedBulkQuery_1 = require("./usePaginatedBulkQuery");
Object.defineProperty(exports, "usePaginatedBulkQuery", { enumerable: true, get: function () { return usePaginatedBulkQuery_1.default; } });
//# sourceMappingURL=index.js.map